import React from "react";

export function DashbboardHelp1() {
    return (
        <div style={{
            fontFamily: 'PPMoriRegular',
            textAlign: 'justify',
            marginRight: 40,
            fontSize: '1.2em'
        }}>
            <p>In many regions the building sector plays a crucial role in the
                overall energy consumption and associated carbon dioxide (CO2) emissions. The energy used for
                heating, cooling, and lighting in buildings significantly impacts the region's carbon footprint.
                Given Indonesian tropical climate, the demand for cooling is particularly high, which exacerbates
                energy consumption and increases CO2 emissions. The efficiency of these buildings and the types
                of energy sources utilized are pivotal factors that directly influence their environmental
                impact. The Indonesian energy grid, still relies significantly on
                fossil fuels, such as coal and natural gas. At the same time, renewable energy adoption, such as
                solar panels, is growing but not yet widespread, limiting the immediate impact on reducing CO2
                emissions from buildings.
            </p>
            <p>To account for this, using the the Carbon Footprint Simulator users can calculate emissions
                produced by buildings by considering the following parameters:
                <ul>
                    <li>Building type classification ratio (residential, non-residential, etc.).</li>
                    <li>Fuel ratios for heating, cooling and lighting (gas fuel, liquid fuel, electricity).
                        These values are obtained from the <a href="http://dataportalforcities.org/" target="_blank">Global Covenant of Mayors Data Portal for Cities</a>.
                    </li>
                    <li>Fuel and electricity efficiency for residential and non-residential buildings obtained
                        from the <a href="https://www.c40knowledgehub.org/s/article/Climate-action-for-URBan-sustainability-CURB-scenario-planning-tool" target="_blank">Climate Action for Urban Sustainability (CURB) tool</a>, developed by the World
                        Bank in collaboration with C40 Cities Climate Leadership Group and AECOM.
                    </li>
                    <li>CO2 Emission factor by building type (residential and nonresidential) also derived from
                        CURB.
                    </li>
                </ul>
                By adjusting the area dedicated to both residential and non-residential buildings and modifying
                the fuel mix used for heating and cooling, users can visualize the corresponding rise or fall in
                CO2 emissions within the building sector.
            </p>
        </div>
    )
}